import http from "./axios";
import {isMacSsoNoIos} from 'Utils/device';
import { isSafari } from 'Utils/browser-info';

let service = http();
// post请求
export default function httpPost({ url, params = {}, config = {} }) {
  if(isMacSsoNoIos || isSafari) {
    params.v = new Date().getTime();
  }
  return new Promise((resolve, reject) => {
    service
      .post(url, params, config)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
    // if (config.headers && !config.formData) {
    //   // 临时处理文件上传post无法传formData参数处理
    //   // config.withCredentials = true;
    //   // axios.post(url, params, config).then((res) => {
    //   //   resolve(res.data);
    //   // }).catch(err => {
    //   //   reject(err);
    //   // });
    // } else {
    //   service.post(url, params, config).then((res) => {
    //     resolve(res.data);
    //   }).catch(err => {
    //     reject(err);
    //   });
    // }
  });
}
